module.exports = __webpack_public_path__ + "media/images/default_thumbnail_external_link-a77e3335af42ea5cac9da4b4f5df042f.png";